<template>
  <div class="content">
    <van-notice-bar @click="showOverlay = true" left-icon="info" text="点击这里关注公众号后可获取最新消息通知" />
    <van-sticky>
      <van-nav-bar title="场地方" left-arrow @click-left="goback()" />
    </van-sticky>
    <div class="content_place">
      <div class="place_noticemore">
        <div>你的未读消息</div>
        <!-- <span>查看更多》</span> -->
      </div>
      <van-notice-bar v-for="item in noticeList" class="m-b10" left-icon="info" :text="item.content" mode="closeable" @click="readJumInfo(item)" @close.stop="readInfo(item)" :key="item" />
      <!-- 数据预览+租金数据 -->
      <div class="place_data">
        <div class="data_detail">
          <div>数据概览</div>
          <div class="detail_list">
            <div class="list_item" @click="toLinkPage('/place/placeManagement',0)">
              <div>{{ siteSupplierIndexData.dataPreview_siteCount }}</div>
              <span>房产量</span>
            </div>
            <div class="list_item" @click="toLinkPage('/place/placeManagement',1)">
              <div>{{ siteSupplierIndexData.dataPreview_rentingCount }}</div>
              <span>出租中</span>
            </div>
            <div class="list_item" @click="toLinkPage('/place/placeManagement',2)">
              <div>{{ siteSupplierIndexData.dataPreview_idleCount }}</div>
              <span>空闲中</span>
            </div>
          </div>
        </div>
        <div class="data_detail">
          <div>租金数据</div>
          <div class="detail_list">
            <div class="list_item" @click="toWithdraw">
              <div>{{ siteSupplierIndexData.rentData_alreadyCash }}</div>
              <span>成功提现</span>
            </div>
            <div class="list_item" @click="toWithdraw">
              <div>{{ siteSupplierIndexData.rentData_canCash }}</div>
              <span>可提现</span>
            </div>
            <div class="list_item">
              <div class="item_cash" @click="toWithdraw">去提现</div>
            </div>
          </div>
        </div>
      </div>
      <div class="place_tools">
        <div>快捷工具</div>
      </div>
      <!-- 快捷菜单栏 -->
      <div class="place_menu">
        <div class="menu_list" v-for="(item, index) in toolList" :key="index" @click="toLinkPage(item.url)">
          {{ item.name }}
          <span v-if="item.badge != '' && item.badge != 0">{{ item.badge }}</span>
        </div>
      </div>
    </div>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wrapper">
        <van-image height="150px" @click.stop width="150px" src="/static/images/code.jpg" fit="cover" />
        <p class="text">长按识别二维码关注公众号，及时接收场地信息提醒</p>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { Button, NoticeBar, Image, Overlay } from "vant";
import storage from '@/utils/storage'
export default {
  components: {
    [Button.name]: Button,
    [NoticeBar.name]: NoticeBar,
    [Overlay.name]: Overlay,
    [Image.name]: Image,
  },
  data() {
    return {
      showOverlay: false,
      siteSupplierIndexData: [],
      toolList: [
        { name: "卡位管理", badge: "", url: "/place/placeManagement" },
        { name: "预约管理", badge: "", url: "/place/appointmentManagement" },
        { name: "订单管理", badge: "", url: "/place/orderList" },
        { name: "客户管理", badge: "", url: "/place/clientManagement" },
        { name: "财务流水", badge: "", url: "/place/financialFlow" },
        { name: "合同管理", badge: "", url: "/personal/contractManagement" },
        { name: "员工管理", badge: "", url: "/place/staffManagement" },
        { name: "账号设置", badge: "", url: "/place/placeSetting" },
      ],
      params: {
        status: "",
        keyword: "",
        page: 1,
        size: 8,
      },
      noticeList: [],
    };
  },

  created() {
    //判断是否为场地方
    this.toApplicationForSite();
    //获取场地方信息
    this.siteSupplierApplyDetailAPI();
    // 员工管理-列表
    this.siteSupplierIndex();
    //待处理预约数量
    this.getbadgeNumber();
    //消息列表
    this.getNoticeList();
  },

  methods: {

    //申请成为场地方（判断申请场地状态）
    toApplicationForSite() {
      var that = this;
      that.$api
        .siteSupplierApplyDetailAPI("")
        .then(function (res) {
          var applyStatus = Number(res.data.data.applyStatus);
          if (res.data.code === 200) {
            // 申请状态，1-待审核/2-已完成/3-已拒绝
            if (applyStatus === 1) {
              //跳转提交申请场地成功界面
              that.$router.push({ path: "/personal/materialProgress" });
            } else if (applyStatus === 2) {
              //跳转场地方界面
              //that.$router.push({ name: "Place" });
            } else {
              //跳转申请场地界面
              that.$router.push({ path: "/personal/applicationForSite" });
            }
          }
        })
        .catch(function (err) {
          console.log("error", err);
          that.$router.push({ path: "/personal/applicationForSite" });
        });
    },

    //跳转申请提现界面
    toWithdraw() {
      this.$router.push({ path: "/place/withdraw" });
    },

    // 员工管理-列表
    siteSupplierIndex() {
      var that = this;
      that.$api
        .siteSupplierIndexAPI(that.params)
        .then(function(res) {
          if (res.data.code === 200) {
            that.toolList[1].badge = res.data.data.reservationManageCount;
            that.toolList[2].badge = res.data.data.orderInfoManageCount;
            that.siteSupplierIndexData = res.data.data;
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    //返回上一页
    goback() {
      this.$router.go(-1);
    },

    //跳转到对应界面界面
    toLinkPage(url,typeValue = "") {
      if (url != "") {
        this.$router.push({ path: url, query: {type:typeValue} });
      }
    },

    // 订单-列表
    getbadgeNumber() {
      var that = this;
      that.params.status = 0;
      that.$api
        .siteSupplierListAPI(that.params)
        .then(function(res) {
          if (res.data.code === 200) {
            that.toolList[1].badge = res.data.total;
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    //消息列表
    getNoticeList() {
      var that = this;
      that.$api
        .getNoticeList({
          readstatus: 0,
          page: 1,
          size: 10
        })
        .then(function(res) {
          if (res.data.code === 200) {
            that.noticeList = res.data.dataList;
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    readJumInfo(item) {
      var that = this;
      that.readInfo(item)
      that.$api
        .readNoticeInfo({
          ids: item.id
        })
        .then(function(res) {
          if (res.data.code === 200) {
            if (item.businessType === "1010") {
              //用戶
              that.$router.push({ path: '/personal/index' });
            } else if (item.businessType === "1011" || item.businessType === "1041") {
              //用戶/分销商提现
              that.$router.push({ path: '/distribution/withdraw' });
            } else if (item.businessType === "1040") {
              //分销商
              that.$router.push({ path: '/distribution/index' });
            } else if (item.businessType === "1050") {
              //合同
              that.$router.push({ path: '/personal/contractManagement' });
            } else if (item.businessType === "1070") {
              //订单
              that.$router.push({ path: '/place/orderList' });
            } else if (item.businessType === "1081" || item.businessType === "1082") {
              //预约管理
              that.$router.push({ path: '/place/appointmentManagement' });
            } else {
              that.getNoticeList();
            }
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },
    //申请场地-入驻申请-查看
    siteSupplierApplyDetailAPI() {
      var that = this;
      that.$api
        .siteSupplierApplyDetailAPI("")
        .then(function (res) {
          if (res.data.code === 200) {
            var applyStatus = Number(res.data.data.applyStatus);
            // 申请状态，1-待审核/2-已完成/3-已拒绝
            if (applyStatus === 1) {
              //跳转提交申请场地成功界面
              that.$router.push({ path: "/personal/materialProgress" });
            } else if (applyStatus === 2) {
              //跳转场地方界面
              that.$router.push({ name: "Place" });
            } else {
              //跳转申请场地界面
              that.$router.push({ path: "/personal/applicationForSite" });
            }
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },
    //已读消息
    readInfo(item) {
      var that = this;
      that.$api
        .readNoticeInfo({
          ids: item.id
        })
        .then(function(res) {
          if (res.data.code === 200) {
            // if (item.businessType === "1010") {
            //   //用戶
            //   that.$router.push({ path: '/personal/index' });
            // } else if (item.businessType === "1011" || item.businessType === "1041") {
            //   //用戶/分销商提现
            //   that.$router.push({ path: '/distribution/withdraw' });
            // } else if (item.businessType === "1040") {
            //   //分销商
            //   that.$router.push({ path: '/distribution/index' });
            // } else if (item.businessType === "1050") {
            //   //合同
            //   that.$router.push({ path: '/personal/contractManagement' });
            // } else if (item.businessType === "1070") {
            //   //订单
            //   that.$router.push({ path: '/place/orderList' });
            // } else if (item.businessType === "1081" || item.businessType === "1082") {
            //   //预约管理
            //   that.$router.push({ path: '/place/appointmentManagement' });
            // } else {
            //   that.getNoticeList();
            // }
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },
  },
};

</script>
<style lang="less">
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
}

.text {
  margin-top: 30px;
  font-size: 16px;
  color: #0cadfc;
}

.content_place {
  padding: 20px 15px;

  .place_noticemore {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    font-weight: bolder;
    align-items: center;
    padding: 10px 0px;

    span {
      color: #0cadfc;
      font-size: 14px;
      font-weight: normal;
    }
  }

  // 数据预览+租金数据

  .place_data {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: #fff;
    margin-top: 5px;

    .data_detail {
      display: flex;
      flex-direction: column;
      margin-top: 15px;
      padding: 15px;
      background: #0cadfc;
      border-radius: 10px;

      .detail_list {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0px 15px;

        .list_item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;

          div {
            font-size: 16px;
            font-weight: bold;
            padding: 10px 0px;
          }

          .item_cash {
            background: #b0aa29;
            border-radius: 5px;
            font-size: 12px;
            padding: 5px 8px;
            margin-top: 20px;
          }
        }
      }
    }
  }

  .van-notice-bar {
    background: #fff2de;
    color: #ffb435;
    border: 1px solid #ffb435;
    border-radius: 10px;
  }

  .place_tools {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    font-weight: bolder;
    align-items: center;
    padding-top: 10px;
  }

  // 快捷菜单栏
  .place_menu {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .menu_list {
      margin-top: 20px;
      width: 47%;
      height: 70px;
      line-height: 70px;
      text-align: center;
      font-size: 13px;
      color: #0cadfc;
      background: #eaeaea;
      border-radius: 5px;
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
      position: relative;

      span {
        position: absolute;
        top: 8px;
        left: 66%;
        background: #ff5151;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: block;
        line-height: 22px;
        color: #fff;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/place/index.vue